import React, { useState, useEffect } from 'react'
import { Button } from 'flowbite-react';
import { useAccountApi } from "../../store";
import Loader from '../shared/Loader';
import AlertComponent from '../shared/AlertComponent';
import BackButton from '../shared/BackButton';
import UserInfo from './UserInfo';

const UserSearch = () => {
    const { getUserDetails } = useAccountApi();

    const [currentSubView, setCurrentSubView] = useState<string>('search');
    const [message, setMessage] = useState<string>('');
    const [userId, setUserId] = useState<string>('');
    const [user, setUser] = useState<any>();

    useEffect(() => {
        document.title = 'FestiShare Support - Users';
    }, []);

    const getUserInfo = async (id: string) => {
        setCurrentSubView('loader');
        try {
            const result: any = await getUserDetails({ userId: id });
            if (result?.res === 'success') {
                setUser(result.data);
                setUserId(result.userId);
                setCurrentSubView('default');
            } else {
                setMessage(result?.message || 'User not found.');
                setCurrentSubView('error');
            }
        } catch {
            setMessage('An unexpected error occurred.');
            setCurrentSubView('error');
        }
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const idValue = e.currentTarget.userId.value;
        setUserId(idValue);
        getUserInfo(idValue);
    };

    return (
        <div className="mt-20 mb-20">
            <div className="mx-auto max-w-3xl px-6 lg:px-8">
                <h2 className="text-base font-semibold leading-7 text-gray-900">
                    Information about the user
                </h2>

                {currentSubView === 'loader' && <Loader />}

                {currentSubView === 'search' && (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-2 block mt-6">
                            <label
                                htmlFor="userId"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                User Id OR email OR username
                            </label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="userId"
                                    id="userId"
                                    required
                                    defaultValue={userId}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>
                        <div className="w-full flex justify-center mt-6">
                            <Button type='submit'>Continue</Button>
                        </div>
                    </form>
                )}

                {user && currentSubView === 'default' && (
                    <div>
                        <UserInfo user={user} />
                        <BackButton callBack={() => setCurrentSubView('search')} />
                    </div>
                )}

                {currentSubView === 'error' && (
                    <AlertComponent
                        callBack={() => setCurrentSubView('search')}
                        type='error'
                        subject='Failed'
                        message={message}
                    />
                )}
            </div>
        </div>
    );
};

export default UserSearch;
